<template>
  <div id="app">
    <main-header />

    <main class="section">
      <div class="container is-widescreen">
        <transition
          name="fade"
          leave-active-class="fadeOutLeft"
          mode="out-in"
        >
          <router-view />
        </transition>
      </div>
    </main>

    <main-footer />
    <b-loading
      :active.sync="loading"
      :can-cancel="true"
    />
  </div>
</template>

<script>
export default {
  name: 'App',
  metaInfo: {
    titleTemplate: '%s | OK K.O.! Fansite'
  },
  data () {
    return {
      mntDelay: 300,
      loading: true,
      currentTs: parseInt(Date.now() / 1000, 10),
      tweets: [],
      tumblr: {
        latest: false,
        previous: []
      },
      schedule: {
        ready: false,
        episodes: [],
        premieres: [],
        premiereTs: []
      },
      downloads: {
        ready: false,
        ep: [],
        ep_legal: null,
        sh: [],
        sh_legal: null,
        co: [],
        co_legal: null,
        mu: [],
        mu_legal: null,
        restricted: false,
        ext_blocked: false,
        country: false,
        whitelist: [
          'CH',
          'FR',
          'DE',
          'UK',
          'ES',
          'MX',
          'RU',
          'PT'
        ]
      },
      links_ressources: [],
      previews: [],
      timeline: []
    }
  },
  mounted () {
    // Shortcut and URL to our API
    var t = this
    var allUrl = 'https://data.okko.fun/api/latest/all.json'

    if (window.navigator.userAgent.indexOf('PhantomJS') > -1) {
      // Dont' go fetch data if we're using PhantomJS
      t.loading = false
      return
    }

    // Fetch our API
    fetch(allUrl)
      .then(data => {
        return data.json()
      }, err => {
        console.log(err)
      })
      .then(json => {
        // Premieres
        Object.keys(json['premiere-ts']).map(pKey => {
          t.schedule.premiereTs.push(json['premiere-ts'][pKey]['ts'])
          if (json['premiere-ts'][pKey]['ts'] > t.currentTs) {
            t.schedule.premieres.push(json['premiere-ts'][pKey])
          }
        })

        // Tumblr posts
        t.tumblr.latest = json['tumblr-posts'][0]
        t.tumblr.previous = json['tumblr-posts'].slice(1)

        // Links
        t.links_ressources = json['links']

        // Timline
        t.timeline = json['timeline']
      })
      .then(() => {
        // Get the schedule
        let scheduleUrl = 'https://api.ctoon.network/schedule/v2/current'

        fetch(scheduleUrl)
          .then(data => {
            return data.json()
          }, err => {
            console.log(err)
            t.schedule.ready = true
          })
          .then(json => {
            for (var day in json) {
              json[day]['schedule']['zap'].forEach(e => {
                if (e['show'] === 'OK K.O.! Let\'s Be Heroes') {
                  t.schedule.episodes.push({
                    'timestamp': e['timestamp'],
                    'episode': e['title']
                  })
                }
              })
            }
            t.schedule.ready = true
          })

        // Get the previews
        /*
        var prevUrl = 'https://api.ctoon.network/previews/shows/2'
        fetch(prevUrl)
          .then(data => {
            return data.json()
          }, err => {
            console.log(err)
          })
          .then(json => {
            t.previews = json
          })
        */

        // Get the downloads
        var dlUrl = 'https://data.okko.fun/api/latest/downloads.json'
        // var checkCountry = 'https://okko-region.herokuapp.com/json/'

        /*
        if (localStorage.getItem('awesome') === 'yes') {
          t.restricted = true
          return
        }
        */

        // Fetch our downloads
        fetch(dlUrl)
          .then(data => {
            return data.json()
          }, err => {
            console.error(err)
            t.downloads.ready = true
          }).catch(() => {
            console.error('Something broke when getting downloads bro.')
            t.downloads.ext_blocked = true
            t.downloads.ready = true
          })
          .then(json => {
            if (json['error']) {
              if (json['error']['code'] === 451) {
                t.restricted = true
                localStorage.setItem('awesome', 'yes')
              } else {
                console.error('Something broke when getting downloads bro.\n' + json['error']['message'])
                t.downloads.ext_blocked = true
              }
              t.downloads.ready = true

              return
            }

            t.downloads.ep = json['episodes']['list']
            t.downloads.ep_legal = json['episodes']['legal_links']
            t.downloads.sh = json['shorts']['list']
            t.downloads.sh_legal = json['shorts']['legal_links']
            t.downloads.co = json['comics']['list']
            t.downloads.co_legal = json['comics']['legal_links']
            t.downloads.mu = json['soundtrack']['list']
            t.downloads.mu_legal = json['soundtrack']['legal_links']

            t.downloads.ready = true
        })

        /*

        fetch(checkCountry)
          .then(data => {
            return data.json()
          })
          .catch(() => {
            console.error('Something broke when getting the country bro.')
            t.downloads.ext_blocked = true
            t.downloads.ready = true
          })
          .then(json => {
            t.downloads.country = json['country_code']
            if (t.downloads.country === 'A1' && localStorage.getItem('ImADick') !== 'totally') {
              localStorage.setItem('awesome', 'yes')
              t.restricted = true
              t.downloads.ready = true
            }
          })
          */
      })
      .then(() => {
        // Close loading
        setTimeout(function () {
          t.loading = false
        }, 500)
      })
  },
  methods: {
    getDate: (ts) => {
      // Get current timestamp and check if current element is on air
      var dateObj = new Date(ts * 1000)
      return dateObj.toLocaleString(navigator.language, {weekday: 'long', day: '2-digit', month: '2-digit', year: 'numeric', hour: '2-digit', minute: '2-digit'})
    }
  }
}
</script>

<style lang="scss">
@import './assets/styles';
</style>
